export default __webpack_public_path__ + "static/media/CNo.77-5.6865e467.jpg";